// extracted by mini-css-extract-plugin
module.exports = {"hot":"hot-1NJ2DKa4 clearfix","title":"title-3QUbvQmI","text":"text-1m481jc2"};